// Account Registration Page – Pre-populate Currency and Timezone Fields
// https://quip-amazon.com/slvWAyeTbdA4/Account-Registration-Page-Pre-populate-Currency-and-Timezone-Fields

export const countryCurrencyTimezoneMap = new Map<
  string,
  { currency: string; timezone: string }
>([
  ['AF', { currency: 'USD', timezone: 'ASIA_KABUL' }], // Afghanistan
  ['AX', { currency: 'EUR', timezone: 'EUROPE_STOCKHOLM' }], // Aland Islands
  ['AL', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Albania
  ['DZ', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Algeria
  ['AS', { currency: 'USD', timezone: 'PACIFIC_MIDWAY' }], // American Samoa
  ['AD', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Andorra
  ['AO', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Angola
  ['AI', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Anguilla
  ['AQ', { currency: 'USD', timezone: 'PACIFIC_AUCKLAND' }], // Antarctica
  ['AG', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Antigua and Barbuda
  ['AR', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Argentina
  ['AM', { currency: 'USD', timezone: 'ASIA_YEREVAN' }], // Armenia
  ['AW', { currency: 'USD', timezone: 'AMERICA_CARACAS' }], // Aruba
  ['AU', { currency: 'AUD', timezone: 'AUSTRALIA_SYDNEY' }], // Australia
  ['AT', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Austria
  ['AZ', { currency: 'USD', timezone: 'ASIA_YEREVAN' }], // Azerbaijan
  ['BS', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Bahamas, The
  ['BH', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Bahrain
  ['BD', { currency: 'USD', timezone: 'ASIA_KOLKATA' }], // Bangladesh
  ['BB', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Barbados
  ['BY', { currency: 'USD', timezone: 'EET' }], // Belarus
  ['BE', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Belgium
  ['BZ', { currency: 'USD', timezone: 'AMERICA_CHICAGO' }], // Belize
  ['BJ', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Benin
  ['BM', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Bermuda
  ['BT', { currency: 'USD', timezone: 'ASIA_KOLKATA' }], // Bhutan
  ['BO', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Bolivia
  ['BQ', { currency: 'USD', timezone: 'AMERICA_CARACAS' }], // Bonaire, Saint Eustatius and Saba
  ['BA', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Bosnia and Herzegovina
  ['BW', { currency: 'USD', timezone: 'EET' }], // Botswana
  ['BV', { currency: 'USD', timezone: 'ATLANTIC_SOUTH_GEORGIA' }], // Bouvet Island
  ['BR', { currency: 'BRL', timezone: 'AMERICA_SAO_PAULO' }], // Brazil
  ['IO', { currency: 'USD', timezone: 'INDIAN_COCOS' }], // British Indian Ocean Territory
  ['BN', { currency: 'USD', timezone: 'ASIA_SINGAPORE' }], // Brunei Darussalam
  ['BG', { currency: 'EUR', timezone: 'EET' }], // Bulgaria
  ['BF', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Burkina Faso
  ['BI', { currency: 'USD', timezone: 'EET' }], // Burundi
  ['KH', { currency: 'USD', timezone: 'ASIA_BANGKOK' }], // Cambodia
  ['CM', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Cameroon
  ['CA', { currency: 'CAD', timezone: 'AMERICA_NEW_YORK' }], // Canada
  ['IC', { currency: 'EUR', timezone: 'EUROPE_LONDON' }], // Canary Islands
  ['CV', { currency: 'USD', timezone: 'ATLANTIC_AZORES' }], // Cape Verde
  ['KY', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Cayman Islands
  ['CF', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Central African Republic
  ['TD', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Chad
  ['CL', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Chile
  ['CN', { currency: 'CNY', timezone: 'ASIA_SHANGHAI' }], // China
  ['CX', { currency: 'AUD', timezone: 'ASIA_BANGKOK' }], // Christmas Island
  ['CC', { currency: 'AUD', timezone: 'INDIAN_COCOS' }], // Cocos (Keeling) Islands
  ['CO', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Colombia
  ['KM', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Comoros
  ['CG', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Congo
  ['CD', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Congo, The Democratic Republic of the
  ['CK', { currency: 'NZD', timezone: 'PACIFIC_HONOLULU' }], // Cook Islands
  ['CR', { currency: 'USD', timezone: 'AMERICA_CHICAGO' }], // Costa Rica
  ['CI', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Cote D'ivoire
  ['HR', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Croatia
  ['CU', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Cuba
  ['CW', { currency: 'USD', timezone: 'AMERICA_CARACAS' }], // Curaçao
  ['CY', { currency: 'EUR', timezone: 'EET' }], // Cyprus
  ['CZ', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Czech Republic
  ['DK', { currency: 'DKK', timezone: 'EUROPE_PARIS' }], // Denmark
  ['DJ', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Djibouti
  ['DM', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Dominica
  ['DO', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Dominican Republic
  ['EC', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Ecuador
  ['EG', { currency: 'EGP', timezone: 'EET' }], // Egypt
  ['SV', { currency: 'USD', timezone: 'AMERICA_CHICAGO' }], // El Salvador
  ['GQ', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Equatorial Guinea
  ['ER', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Eritrea
  ['EE', { currency: 'EUR', timezone: 'EET' }], // Estonia
  ['ET', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Ethiopia
  ['FK', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Falkland Islands (Malvinas)
  ['FO', { currency: 'DKK', timezone: 'EUROPE_LONDON' }], // Faroe Islands
  ['FJ', { currency: 'USD', timezone: 'PACIFIC_FIJI' }], // Fiji
  ['FI', { currency: 'EUR', timezone: 'EET' }], // Finland
  ['FR', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // France
  ['GF', { currency: 'EUR', timezone: 'AMERICA_SAO_PAULO' }], // French Guiana
  ['PF', { currency: 'USD', timezone: 'PACIFIC_HONOLULU' }], // French Polynesia
  ['TF', { currency: 'EUR', timezone: 'INDIAN_COCOS' }], // French Southern Territories
  ['GA', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Gabon
  ['GM', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Gambia, The
  ['GE', { currency: 'USD', timezone: 'ASIA_YEREVAN' }], // Georgia
  ['DE', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Germany
  ['GH', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Ghana
  ['GI', { currency: 'GBP', timezone: 'EUROPE_PARIS' }], // Gibraltar
  ['GR', { currency: 'EUR', timezone: 'EET' }], // Greece
  ['GL', { currency: 'DKK', timezone: 'AMERICA_ST_JOHNS' }], // Greenland
  ['GD', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Grenada
  ['GP', { currency: 'EUR', timezone: 'AMERICA_NEW_YORK' }], // Guadeloupe
  ['GU', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Guam
  ['GT', { currency: 'USD', timezone: 'AMERICA_CHICAGO' }], // Guatemala
  ['GG', { currency: 'GBP', timezone: 'EUROPE_LONDON' }], // Guernsey
  ['GN', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Guinea
  ['GW', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Guinea-Bissau
  ['GY', { currency: 'USD', timezone: 'AMERICA_CARACAS' }], // Guyana
  ['HT', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Haiti
  ['HM', { currency: 'AUD', timezone: 'INDIAN_COCOS' }], // Heard Island and the McDonald Islands
  ['VA', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Holy See
  ['HN', { currency: 'USD', timezone: 'AMERICA_CHICAGO' }], // Honduras
  ['HK', { currency: 'USD', timezone: 'ASIA_HONG_KONG' }], // Hong Kong
  ['HU', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Hungary
  ['IS', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Iceland
  ['IN', { currency: 'INR', timezone: 'ASIA_KOLKATA' }], // India
  ['ID', { currency: 'USD', timezone: 'ASIA_BANGKOK' }], // Indonesia
  ['IR', { currency: 'USD', timezone: 'ASIA_TEHRAN' }], // Iran, Islamic Republic of
  ['IQ', { currency: 'USD', timezone: 'ASIA_BAGHDAD' }], // Iraq
  ['IE', { currency: 'EUR', timezone: 'EUROPE_LONDON' }], // Ireland
  ['IM', { currency: 'GBP', timezone: 'EUROPE_LONDON' }], // Isle of Man
  ['IL', { currency: 'USD', timezone: 'EET' }], // Israel
  ['IT', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Italy
  ['JM', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Jamaica
  ['JP', { currency: 'JPY', timezone: 'ASIA_TOKYO' }], // Japan
  ['JE', { currency: 'GBP', timezone: 'EUROPE_LONDON' }], // Jersey
  ['JO', { currency: 'USD', timezone: 'EET' }], // Jordan
  ['KZ', { currency: 'USD', timezone: 'ASIA_ALMATY' }], // Kazakhstan
  ['KE', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Kenya
  ['KI', { currency: 'AUD', timezone: 'PACIFIC_KWAJALEIN' }], // Kiribati
  ['KP', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Korea, Democratic People's Republic of
  ['KR', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Korea, Republic of
  ['XK', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Kosovo
  ['KW', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Kuwait
  ['KG', { currency: 'USD', timezone: 'ASIA_ALMATY' }], // Kyrgyzstan
  ['LA', { currency: 'USD', timezone: 'ASIA_BANGKOK' }], // Lao People's Democratic Republic
  ['LV', { currency: 'EUR', timezone: 'EET' }], // Latvia
  ['LB', { currency: 'USD', timezone: 'EET' }], // Lebanon
  ['LS', { currency: 'ZAR', timezone: 'EET' }], // Lesotho
  ['LR', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Liberia
  ['LY', { currency: 'USD', timezone: 'EET' }], // Libya
  ['LI', { currency: 'CHF', timezone: 'EUROPE_PARIS' }], // Liechtenstein
  ['LT', { currency: 'EUR', timezone: 'EET' }], // Lithuania
  ['LU', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Luxembourg
  ['MO', { currency: 'USD', timezone: 'ASIA_HONG_KONG' }], // Macao
  ['MK', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Macedonia, The Former Yugoslav Republic of
  ['MG', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Madagascar
  ['MW', { currency: 'USD', timezone: 'EET' }], // Malawi
  ['MY', { currency: 'USD', timezone: 'ASIA_SINGAPORE' }], // Malaysia
  ['MV', { currency: 'USD', timezone: 'ASIA_KOLKATA' }], // Maldives
  ['ML', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Mali
  ['MT', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Malta
  ['MH', { currency: 'USD', timezone: 'PACIFIC_KWAJALEIN' }], // Marshall Islands
  ['MQ', { currency: 'EUR', timezone: 'AMERICA_NEW_YORK' }], // Martinique
  ['MR', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Mauritania
  ['MU', { currency: 'USD', timezone: 'INDIAN_COCOS' }], // Mauritius
  ['YT', { currency: 'EUR', timezone: 'ASIA_RIYADH' }], // Mayotte
  ['MX', { currency: 'MXN', timezone: 'AMERICA_MEXICO_CITY' }], // Mexico
  ['FM', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Micronesia, Federated States of
  ['MD', { currency: 'USD', timezone: 'EET' }], // Moldova, Republic of
  ['MC', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Monaco
  ['MN', { currency: 'USD', timezone: 'ASIA_SHANGHAI' }], // Mongolia
  ['ME', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Montenegro
  ['MS', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Montserrat
  ['MA', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Morocco
  ['MZ', { currency: 'USD', timezone: 'EET' }], // Mozambique
  ['MM', { currency: 'USD', timezone: 'ASIA_BANGKOK' }], // Myanmar
  ['NA', { currency: 'ZAR', timezone: 'EET' }], // Namibia
  ['NR', { currency: 'AUD', timezone: 'PACIFIC_KWAJALEIN' }], // Nauru
  ['NP', { currency: 'USD', timezone: 'ASIA_KATHMANDU' }], // Nepal
  ['NL', { currency: 'EUR', timezone: 'EUROPE_AMSTERDAM' }], // Netherlands
  ['AN', { currency: 'USD', timezone: 'AMERICA_CARACAS' }], // Netherlands Antilles
  ['NC', { currency: 'USD', timezone: 'PACIFIC_AUCKLAND' }], // New Caledonia
  ['NZ', { currency: 'NZD', timezone: 'PACIFIC_AUCKLAND' }], // New Zealand
  ['NI', { currency: 'USD', timezone: 'AMERICA_CHICAGO' }], // Nicaragua
  ['NE', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Niger
  ['NG', { currency: 'NGN', timezone: 'EUROPE_PARIS' }], // Nigeria
  ['NU', { currency: 'NZD', timezone: 'PACIFIC_MIDWAY' }], // Niue
  ['NF', { currency: 'AUD', timezone: 'PACIFIC_AUCKLAND' }], // Norfolk Island
  ['MP', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Northern Mariana Islands
  ['NO', { currency: 'NOK', timezone: 'EUROPE_PARIS' }], // Norway
  ['OM', { currency: 'USD', timezone: 'ASIA_DUBAI' }], // Oman
  ['PK', { currency: 'USD', timezone: 'ASIA_KOLKATA' }], // Pakistan
  ['PW', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Palau
  ['PS', { currency: 'USD', timezone: 'EET' }], // Palestinian Territories
  ['PA', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Panama
  ['PG', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Papua New Guinea
  ['PY', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Paraguay
  ['PE', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Peru
  ['PH', { currency: 'USD', timezone: 'ASIA_SINGAPORE' }], // Philippines
  ['PN', { currency: 'USD', timezone: 'PACIFIC_HONOLULU' }], // Pitcairn
  ['PL', { currency: 'PLN', timezone: 'EUROPE_PARIS' }], // Poland
  ['PT', { currency: 'EUR', timezone: 'EUROPE_LONDON' }], // Portugal
  ['PR', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Puerto Rico
  ['QA', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Qatar
  ['RE', { currency: 'EUR', timezone: 'INDIAN_COCOS' }], // Reunion
  ['RO', { currency: 'EUR', timezone: 'EET' }], // Romania
  ['RU', { currency: 'USD', timezone: 'ASIA_YEKATERINBURG' }], // Russian Federation
  ['RW', { currency: 'USD', timezone: 'EET' }], // Rwanda
  ['BL', { currency: 'EUR', timezone: 'AMERICA_NEW_YORK' }], // Saint Barthelemy
  ['SH', { currency: 'GBP', timezone: 'EUROPE_LONDON' }], // Saint Helena, Ascension and Tristan da Cunha
  ['KN', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Saint Kitts and Nevis
  ['LC', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Saint Lucia
  ['MF', { currency: 'EUR', timezone: 'AMERICA_NEW_YORK' }], // Saint Martin
  ['PM', { currency: 'EUR', timezone: 'AMERICA_ST_JOHNS' }], // Saint Pierre and Miquelon
  ['VC', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Saint Vincent and the Grenadines
  ['WS', { currency: 'USD', timezone: 'PACIFIC_MIDWAY' }], // Samoa
  ['SM', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // San Marino
  ['ST', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Sao Tome and Principe
  ['SA', { currency: 'SAR', timezone: 'ASIA_RIYADH' }], // Saudi Arabia
  ['SN', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Senegal
  ['RS', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Serbia
  ['CS', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Serbia and Montenegro
  ['SC', { currency: 'USD', timezone: 'INDIAN_COCOS' }], // Seychelles
  ['SL', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Sierra Leone
  ['SG', { currency: 'SGD', timezone: 'ASIA_SINGAPORE' }], // Singapore
  ['SX', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Sint Maarten
  ['SK', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Slovakia
  ['SI', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Slovenia
  ['SB', { currency: 'USD', timezone: 'PACIFIC_AUCKLAND' }], // Solomon Islands
  ['SO', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Somalia
  ['ZA', { currency: 'ZAR', timezone: 'EET' }], // South Africa
  ['GS', { currency: 'GBP', timezone: 'ATLANTIC_SOUTH_GEORGIA' }], // South Georgia and the South Sandwich Islands
  ['SS', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // South Sudan
  ['ES', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Spain
  ['LK', { currency: 'USD', timezone: 'ASIA_KOLKATA' }], // Sri Lanka
  ['SD', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Sudan
  ['SR', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Suriname
  ['SJ', { currency: 'NOK', timezone: 'EUROPE_PARIS' }], // Svalbard and Jan Mayen
  ['SZ', { currency: 'ZAR', timezone: 'EET' }], // Swaziland
  ['SE', { currency: 'SEK', timezone: 'EUROPE_STOCKHOLM' }], // Sweden
  ['CH', { currency: 'CHF', timezone: 'EUROPE_PARIS' }], // Switzerland
  ['SY', { currency: 'USD', timezone: 'EET' }], // Syria
  ['TW', { currency: 'USD', timezone: 'ASIA_SHANGHAI' }], // Taiwan
  ['TJ', { currency: 'USD', timezone: 'ASIA_YEKATERINBURG' }], // Tajikistan
  ['TZ', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Tanzania, United Republic of
  ['TH', { currency: 'USD', timezone: 'ASIA_BANGKOK' }], // Thailand
  ['TL', { currency: 'USD', timezone: 'ASIA_TOKYO' }], // Timor-leste
  ['TG', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Togo
  ['TK', { currency: 'NZD', timezone: 'PACIFIC_MIDWAY' }], // Tokelau
  ['TO', { currency: 'USD', timezone: 'PACIFIC_MIDWAY' }], // Tonga
  ['TT', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Trinidad and Tobago
  ['TN', { currency: 'USD', timezone: 'EUROPE_PARIS' }], // Tunisia
  ['TR', { currency: 'TRY', timezone: 'EUROPE_ISTANBUL' }], // Turkey
  ['TM', { currency: 'USD', timezone: 'ASIA_YEKATERINBURG' }], // Turkmenistan
  ['TC', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Turks and Caicos Islands
  ['TV', { currency: 'AUD', timezone: 'PACIFIC_KWAJALEIN' }], // Tuvalu
  ['UG', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Uganda
  ['UA', { currency: 'USD', timezone: 'EET' }], // Ukraine
  ['AE', { currency: 'AED', timezone: 'ASIA_DUBAI' }], // United Arab Emirates
  ['GB', { currency: 'GBP', timezone: 'EUROPE_LONDON' }], // United Kingdom
  ['US', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // United States
  ['UM', { currency: 'USD', timezone: 'PACIFIC_HONOLULU' }], // United States Minor Outlying Islands
  ['UY', { currency: 'USD', timezone: 'AMERICA_SAO_PAULO' }], // Uruguay
  ['UZ', { currency: 'USD', timezone: 'ASIA_YEKATERINBURG' }], // Uzbekistan
  ['VU', { currency: 'USD', timezone: 'PACIFIC_AUCKLAND' }], // Vanuatu
  ['VE', { currency: 'USD', timezone: 'AMERICA_CARACAS' }], // Venezuela
  ['VN', { currency: 'USD', timezone: 'ASIA_BANGKOK' }], // Vietnam
  ['VG', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Virgin Islands, British
  ['VI', { currency: 'USD', timezone: 'AMERICA_NEW_YORK' }], // Virgin Islands, U.S.
  ['WF', { currency: 'USD', timezone: 'PACIFIC_KWAJALEIN' }], // Wallis and Futuna
  ['EH', { currency: 'USD', timezone: 'EUROPE_LONDON' }], // Western Sahara
  ['YE', { currency: 'USD', timezone: 'ASIA_RIYADH' }], // Yemen
  ['YU', { currency: 'EUR', timezone: 'EUROPE_PARIS' }], // Yugoslavia
  ['ZM', { currency: 'USD', timezone: 'EET' }], // Zambia
  ['ZW', { currency: 'USD', timezone: 'EET' }], // Zimbabwe
]);
